import { render, staticRenderFns } from "./posNotVisitedJustifications.vue?vue&type=template&id=5c5230f9&"
import script from "./posNotVisitedJustifications.vue?vue&type=script&lang=js&"
export * from "./posNotVisitedJustifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports